(function () {
  if (window.__pqRevealInit) return;
  window.__pqRevealInit = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Activates an element and, if it's a stagger group, cascades "is-visible"
  // across its .pq-reveal-item children with a short delay between each.
  function activate(el) {
    el.classList.add('is-visible');
    if (el.hasAttribute('data-reveal-group')) {
      var items = el.querySelectorAll('.pq-reveal-item');
      var step = parseInt(el.getAttribute('data-reveal-stagger'), 10) || 90;
      items.forEach(function (item, i) {
        if (reduceMotion) {
          item.classList.add('is-visible');
        } else {
          setTimeout(function () { item.classList.add('is-visible'); }, i * step);
        }
      });
    }
  }

  function reveal() {
    var els = document.querySelectorAll('.pq-reveal, [data-reveal-group]');
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(activate);
      return;
    }
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          activate(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) {
      // Elements already sitting in the initial viewport shouldn't wait on the
      // observer's first callback (which can lag behind hero image/layout
      // shifts and briefly show a blank element). Reveal those immediately
      // and only defer to the observer for content further down the page.
      var rect = el.getBoundingClientRect();
      if (rect.bottom > 0 && rect.top < vh * 0.92) {
        activate(el);
      } else {
        observer.observe(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reveal);
  } else {
    reveal();
  }
})();
